import { RowPassengerCountDto } from "@/dtos";
import { PassengerCount } from "@/entities";
import { parseToLocalDateTimeFromUtc } from "@/helpers/utilities";

export const formatRowPassengerCountDto = (passengerCounts: PassengerCount[]): RowPassengerCountDto[] => {
    return passengerCounts.map(x => {
        const row: RowPassengerCountDto = {
            ...x,
            in1: x.details.in1,
            in2: x.details.in2,
            in3: x.details.in3,
            in4: x.details.in4,
            out1: x.details.out1,
            out2: x.details.out2,
            out3: x.details.out3,
            out4: x.details.out4,
            total: x.details.totalDay ?? 0,
            date_time_label: parseToLocalDateTimeFromUtc(x.date + " " + x.hour),
            date_time_created: parseToLocalDateTimeFromUtc(x.created_at.toString()),
            latitude: x.coordinates.latitude,
            longitude: x.coordinates.longitude
        }

        return row;
    });
}